export enum SocietyTypeEnum {
    SocietyCategory = 1,
    SocietyKind = 2,
    SocietyType = 3
  }  